var map = {
	"./video-1.mp4": 6747,
	"./video-10.mp4": 7211,
	"./video-11.mp4": 3270,
	"./video-12.mp4": 8153,
	"./video-13.mp4": 9108,
	"./video-14.mp4": 1831,
	"./video-15.mp4": 9170,
	"./video-16.mp4": 7381,
	"./video-17.mp4": 6208,
	"./video-18.mp4": 3427,
	"./video-19.mp4": 366,
	"./video-2.mp4": 916,
	"./video-3.mp4": 7657,
	"./video-4.mp4": 7730,
	"./video-5.mp4": 5191,
	"./video-6.mp4": 7392,
	"./video-7.mp4": 6981,
	"./video-8.mp4": 9902,
	"./video-9.mp4": 2003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824;